module.exports = __webpack_public_path__ + "media/images/flags/4x3/zaf-0386a651cf88fc6217d8cf96b14ab44d.svg";